/** The account's libraries, uploads and community remixes together, newest
 *  first. Search runs on the server (`myLibraries(search:)` matches the title
 *  and the channel name), so nothing is filtered here. */
export function listUserLibraries<T extends { createdAt: string }>(libraries: T[]): T[] {
  return [...libraries].sort((left, right) => {
    const leftTime = Date.parse(left.createdAt) || 0;
    const rightTime = Date.parse(right.createdAt) || 0;
    return rightTime - leftTime;
  });
}
